export default "__VITE_ASSET__DQt8lT8g__"